// extracted by mini-css-extract-plugin
export default {"auth-root":"AuthLayout_auth-root__PI47U","auth-card":"AuthLayout_auth-card__K1-5c","brand":"AuthLayout_brand__QoCY7","logo":"AuthLayout_logo__-KElk"};